import { Injectable } from '@angular/core';
import {
  BasePageMetaResolver,
  CategoryPageMetaResolver,
  CmsService,
  PageType,
  ProductSearchPage,
  ProductSearchService,
  TranslationService,
} from '@spartacus/core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { CustomProdPgService } from 'src/app/custom-prod-pg/custom-prod-pg.service';

@Injectable({ providedIn: 'root' })
export class CustomCategoryPageMetaResolver extends CategoryPageMetaResolver {
  title$: Observable<string>;

  constructor(
    protected productSearchService: ProductSearchService,
    protected cms: CmsService,
    protected translation: TranslationService,
    protected basePageMetaResolver: BasePageMetaResolver,
    protected productPageService: CustomProdPgService
  ) {
    super(productSearchService, cms, translation, basePageMetaResolver);
    this.pageType = PageType.CATEGORY_PAGE;
    this.pageTemplate = 'ProductGridPageTemplate';
  }

  resolveTitle(): Observable<string> {
    return combineLatest([
      this.productPageService.isFiltered$,
      this.checkIfAllProducts(),
    ]).pipe(
      switchMap(([isFiltered, allProducts]) => {
        if (!isFiltered && allProducts) {
          return this.translation.translate('pageMetaResolver.category.title');
        } else {
          return (this.searchPage$ as Observable<ProductSearchPage>).pipe(
            filter((page: ProductSearchPage) => !!page.pagination),
            switchMap((p: ProductSearchPage) =>
              this.translation.translate(
                'pageMetaResolver.category.title_other',
                {
                  count: p.pagination?.totalResults,
                  query: p.breadcrumbs?.length
                    ? p.breadcrumbs[0].facetValueName
                    : undefined,
                }
              )
            )
          );
        }
      })
    );
  }

  private checkIfAllProducts(): Observable<boolean> {
    return this.searchPage$.pipe(
      map((page: ProductSearchPage) => {
        return (
          !!page.pagination &&
          page.breadcrumbs[0]?.facetValueName === 'Todos os produtos'
        );
      })
    );
  }
}
